import { injectable } from "inversify";
import WCCSliderFadeAnimator from "../animators/fade";
import WCCSliderSlideAnimator from "../animators/slide";
import { ExtendedWCCSlideAnimatorConfig, IWCCSliderAnimatorsFactory } from "./animators.interfaces";

@injectable()
export default class WCCSliderAnimatorsFactory<T> implements IWCCSliderAnimatorsFactory<T> {
    constructor() { }

    build(config: ExtendedWCCSlideAnimatorConfig<T>) {
        switch (config.type) {
            case 'fade':
                return new WCCSliderFadeAnimator(config);
            default:
                return new WCCSliderSlideAnimator(config);
        }
    }
}